import { useState, useContext, useRef, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../jsx/UserContext";
import api from "../jsx/axiosClient";

export function Loginlogic() {
    const { setUserSession } = useContext(UserContext);
    const [formData, setFormData] = useState({ email: "", password: "" });

    const navigate = useNavigate();
    const emailRef = useRef(null);

    useEffect(() => {
        emailRef.current?.focus();

        const storedSession = JSON.parse(localStorage.getItem("userSession"));

        if (!storedSession?.access_token) {
            return;
        }

        if (storedSession.expiresAt && Date.now() > storedSession.expiresAt) {
            localStorage.removeItem("userSession");
            setUserSession({ name: "", access_token: "" });
            return;
        }

        setUserSession(storedSession);
        navigate("/dashboard", { replace: true });
    }, [navigate, setUserSession]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleForgotPassword = () => {
        Swal.fire({
            title: "Forgot Password?",
            input: "email",
            inputLabel: "Enter your registered email",
            inputPlaceholder: "example@email.com",
            showCancelButton: true,
            confirmButtonText: "Send Reset Link",
            confirmButtonColor: "#B0004E",
            cancelButtonColor: "#6c757d",
            preConfirm: async (email) => {
                if (!email) {
                    Swal.showValidationMessage("Please enter an email address");
                    return null;
                }

                try {
                    const body = new FormData();
                    body.append("email", email);

                    const res = await fetch("/forgot-password", {
                        method: "POST",
                        body,
                    });

                    return await res.json();
                } catch (err) {
                    Swal.showValidationMessage(`Error: ${err.message}`);
                    return null;
                }
            },
        }).then((result) => {
            if (!result.isConfirmed || !result.value) {
                return;
            }

            const data = result.value;

            if (data.status === "success") {
                Swal.fire({
                    icon: "success",
                    title: "Reset Link Sent",
                    text: data.message,
                    confirmButtonColor: "#B0004E",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Request Failed",
                    text: data.message || "Unable to send reset link. Please try again.",
                    confirmButtonColor: "#B0004E",
                });
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post("/login", formData);
            const result = response.data;

            console.log("login response", result);

            if (result.status === "success") {
                const expiresAt = Date.now() + 60 * 60 * 1000;

                const sessionData = {
                    name: result.name,
                    access_token: result.access_token,
                    expiresAt,
                    user_type: result.user_type,
                    custom_data: result.custom_data,
                };

                console.log("sessionData in Loginlogic", sessionData);

                setUserSession(sessionData);
                localStorage.setItem("userSession", JSON.stringify(sessionData));

                navigate("/dashboard", { replace: true });
                return;
            }

            Swal.fire({
                icon: "error",
                title: "Login Failed",
                text: result.message || "Invalid email or password.",
                confirmButtonColor: "#B0004E",
            });
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Network Error",
                text: err.response?.data?.message || err.message,
                confirmButtonColor: "#B0004E",
            });
        }
    };

    return {
        formData,
        handleChange,
        handleForgotPassword,
        handleSubmit,
        navigate,
        emailRef,
    };
}